const SET_GATEWAYS = 'app/gateways/SET_GATEWAYS';
const SET_CURRENT_GATEWAY = 'app/gateways/SET_CURRENT_GATEWAY';
const CLEAN_GATEWAY_DATA = 'app/gateways/CLEAN_GATEWAY_DATA';

const initialState = {
    currentGateway: null,
    gatewaysData: null,
};

export default function reducer(state = {...initialState}, action) {
    switch (action.type) {
        case SET_CURRENT_GATEWAY: {
            const payload = action.payload || {};

            return {...state, currentGateway: payload};
        }
        case SET_GATEWAYS: {
            const payload = action.payload || {};

            return {...state, gatewaysData: payload};
        }
        case CLEAN_GATEWAY_DATA: {
            return {...state, ...initialState};
        }
        default:
            return state;
    }
}

export const setGateways = (payload) => ({
    type: SET_GATEWAYS,
    payload,
});

export const setCurrentGateway = (payload) => ({
    type: SET_CURRENT_GATEWAY,
    payload,
});

export const cleanGatewayData = () => ({
    type: CLEAN_GATEWAY_DATA,
});
